// Pure queue derivation for the Property Review triage bar — colocated with
// PropertyReviewModal per this directory's pure-helper pattern
// (see propertySaveHelpers.js in HMI/PropertyOverview).

export const TRIAGE_FILTERS = [
  { key: 'takeoffIncomplete', label: 'Takeoff Incomplete', test: p => !p.siteTakeoff?.complete },
  // Also matches properties with no takeoff at all: nothing marked includes nothing exists.
  { key: 'noHerbicideAreas', label: 'No Herbicide Areas', test: p => !p.siteTakeoff?.hasHerbicideAreas },
  { key: 'linesUnverified', label: 'Lines Not Verified', test: p => !p.setupChecklist?.propertyLinesVerified?.confirmed },
  { key: 'noGeofence', label: 'No Geofence', test: p => !p.setupChecklist?.geofenceSet?.confirmed },
  { key: 'noLatLng', label: 'No Lat/Lng', test: p => !(p.latitude && p.longitude) },
  { key: 'noJobsite', label: 'No Takeoff Site', test: p => !p.jobsiteId }
]

const SEARCH_FIELDS = ['propertyName', 'name', 'companyName', 'address1', 'communityName', 'buildingNumber']

export const matchesSearch = (property = {}, query) => {
  const q = String(query || '').trim().toLowerCase()
  if (!q) return true
  return SEARCH_FIELDS.some(field => {
    const value = property[field]
    return value != null && String(value).toLowerCase().includes(q)
  })
}

// Chips OR together; search then narrows. Preserves input order (the fetch
// order of /api/aspire/routing/properties) — no sort control in v1.
export const buildReviewQueue = (properties = [], { search = '', activeKeys } = {}) => {
  const keys = activeKeys instanceof Set ? activeKeys : new Set(activeKeys || [])
  const activeTests = TRIAGE_FILTERS.filter(f => keys.has(f.key)).map(f => f.test)
  return properties.filter(p =>
    (activeTests.length === 0 || activeTests.some(test => test(p))) && matchesSearch(p, search)
  )
}
